import React from 'react';
import { OneLineInput } from '../⚛️atoms/OneLineInput';
import { TiptapEditor } from '../⚛️atoms/TiptapEditor';
import PdSelect from '../PdSelect';
import { MarkdownWrapper } from './MarkdownWrapper';
import useLockedTranslate from '../../Hooks/useLockedTranslate';
import { getTranslation, updateTranslation } from '../../utils/translationHelper';
import { TranslateButton } from '../atoms/translateButton';
import { cloneWorkbookV2Value } from './editorUtils';

export const WorkbookV2Header = ({ item, updateItem, editing, editingLanguage = null, workbook }) => {
  const { lang } = useLockedTranslate(workbook);

  const updateEditorItem = (updates) => {
    const nextItem = cloneWorkbookV2Value(item);
    nextItem.text = updates.text ?? nextItem.text;
    nextItem.page_number = updates.page_number ?? nextItem.page_number;
    nextItem.translations = updates.translations ?? nextItem.translations;
    nextItem.options = {
      ...(nextItem.options ?? {}),
      ...(updates.options ?? {})
    };
    updateItem(nextItem);
  };

  const sizeOptions = {
    '': [
      { label: 'Small', value: 'small' },
      { label: 'Medium', value: 'medium' },
      { label: 'Large', value: 'large' }
    ]
  };

  const headerTag = () => {
    switch (item.options?.size) {
      case 'small':
        return (
          <h4 className="[&_p]:text-3xl!">
            <MarkdownWrapper>{lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text', item.text)}</MarkdownWrapper>
          </h4>
        );
      case 'medium':
        return (
          <h3 className="[&_p]:text-4xl!">
            <MarkdownWrapper>{lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text', item.text)}</MarkdownWrapper>
          </h3>
        );
      case 'large':
        return (
          <h2 className="[&_p]:text-5xl!">
            <MarkdownWrapper>{lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text', item.text)}</MarkdownWrapper>
          </h2>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`flex w-full items-center gap-2 ${editing && 'border-pdteal rounded-lg border-2 px-8 py-12'}`}>
      {!editing && headerTag()}
      {editing && (
        <div className="flex w-full flex-col gap-8">
          <div className="flex w-full items-center gap-2">
            <div className="relative w-full">
              <p className="mb-2 text-xl/6 font-medium text-gray-900">Text</p>
              <TiptapEditor content={item.text} onChange={(value) => updateEditorItem({ text: value })} />
              {editingLanguage && (
                <TranslateButton
                  text={item.text}
                  language={editingLanguage}
                  onResponse={(value) =>
                    updateEditorItem({
                      translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                    })
                  }
                />
              )}
            </div>
            {editingLanguage && (
              <div>
                <p className="mb-2 text-xl/6 font-medium text-gray-900">Text ({editingLanguage})</p>
                <TiptapEditor
                  content={getTranslation(item.translations, editingLanguage, 'text')}
                  onChange={(value) =>
                    updateEditorItem({
                      translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                    })
                  }
                />
              </div>
            )}
            <div className="w-1/5">
              <PdSelect
                groupedOptions={sizeOptions}
                onOptionClick={(value) => updateEditorItem({ options: { size: value } })}
                id="header-size"
                placeholder="size"
                required
                value={item.options?.size}
              />
            </div>
          </div>
          <div className="w-1/5">
            <OneLineInput
              value={item.page_number}
              label="Page Number"
              onChange={(value) => updateEditorItem({ page_number: value })}
            />
          </div>
        </div>
      )}
    </div>
  );
};
